import React from 'react';
import { ArrowTopRightOnSquareIcon, CalendarDaysIcon } from '@heroicons/react/24/outline';
import { PARENT_ACTIVITIES_EVENTS_URL } from '../config/siteLinks';

/**
 * Link out to Activities & Events on the parent Sizzle site.
 * Renders nothing until REACT_APP_PARENT_ACTIVITIES_URL is configured.
 */
const ActivitiesEventsLink = ({ variant = 'outline', className = '' }) => {
  if (!PARENT_ACTIVITIES_EVENTS_URL) return null;

  const isSolid = variant === 'solid';
  const isGhost = variant === 'ghost';

  const borderColor = isGhost ? '#F9EFDD' : '#A08D45';
  const textColor = isSolid ? '#fff' : isGhost ? '#F9EFDD' : '#A08D45';

  return (
    <a
      href={PARENT_ACTIVITIES_EVENTS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-heading uppercase tracking-wide border transition-colors ${className}`}
      style={{
        borderRadius: 0,
        fontWeight: 500,
        backgroundColor: isSolid ? '#A08D45' : 'transparent',
        borderColor,
        color: textColor,
      }}
      onMouseEnter={(e) => {
        if (isSolid) {
          e.currentTarget.style.backgroundColor = '#8a7938';
          e.currentTarget.style.borderColor = '#8a7938';
        } else if (isGhost) {
          e.currentTarget.style.backgroundColor = 'rgba(249,239,221,0.12)';
        } else {
          e.currentTarget.style.backgroundColor = 'rgba(160,141,69,0.08)';
          e.currentTarget.style.borderColor = '#8a7938';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = isSolid ? '#A08D45' : 'transparent';
        e.currentTarget.style.borderColor = borderColor;
        e.currentTarget.style.color = textColor;
      }}
    >
      <CalendarDaysIcon className="h-5 w-5" aria-hidden />
      Activities &amp; Events
      <ArrowTopRightOnSquareIcon className="h-4 w-4 opacity-70" aria-hidden />
    </a>
  );
};

export default ActivitiesEventsLink;
